var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"sub_wrapper"},[_c('img',{attrs:{"src":require(`@/assets/add_plugin_filled_shadow.svg`),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }